// extracted by mini-css-extract-plugin
module.exports = {"a1tdgj4y":"a1tdgj4y","wcnkszl":"wcnkszl"};